import { render, staticRenderFns } from "./HuaWei.vue?vue&type=template&id=4b880c6b&scoped=true&"
import script from "./HuaWei.vue?vue&type=script&lang=js&"
export * from "./HuaWei.vue?vue&type=script&lang=js&"
import style0 from "./HuaWei.vue?vue&type=style&index=0&id=4b880c6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b880c6b",
  null
  
)

export default component.exports